import { useState } from "react"
import Loader from "./Loader"

export const IsLoading = (Component, message) => {
    function LoadingComponent(props) {
        const [isLoading, setIsLoading] = useState(false)

        const setLoadingState = isComponentLoading => {
            setIsLoading(isComponentLoading)
        }
        return (
            <>
                {isLoading && <Loader message={message} />}
                <Component {...props} setLoading={setLoadingState} />
            </>
        )
    }
    return LoadingComponent
}

export default IsLoading